import { oc } from '@orpc/contract';
import { listUsersInputSchema, listUsersOutputSchema } from '../schemas/users.schemas.js';
export const listUsersContract = oc
    .route({
    method: 'GET',
    path: '/users',
    tags: ['Users'],
    summary: "List the users of the caller's tenant",
})
    .input(listUsersInputSchema)
    .output(listUsersOutputSchema);
//# sourceMappingURL=list-users.contract.js.map